import Button from "../Button";
import MultiSelectDropdown from "../MultiSelectDropdown";
import CreatableMultiSelect from "../CreatableMultiSelect";

const StepBasicMetadata = ({
  formData,
  handleInputChange,
  handleDropdownChange,
  sourceOptions,
  contentTypeOptions,
  handleNext,
  setContenttypeOptions,
  setSourceOptions,
  sourceLoadOptions,
  contentTypeLoadOptions,
}) => {
  // Normalize selections for display
  const normalizedSource = Array.isArray(formData.source)
    ? formData.source.map((s) => s.toString().trim().toLowerCase())
    : typeof formData.source === "string" && formData.source.startsWith("[")
      ? JSON.parse(formData.source).map((s) => s.toString().trim().toLowerCase())
      : typeof formData.source === "string"
        ? [formData.source.toString().trim().toLowerCase()]
        : [];

  const normalizedContentType = Array.isArray(formData.contentType)
    ? formData.contentType.map((c) => c.toString().trim().toLowerCase())
    : typeof formData.contentType === "string" && formData.contentType.startsWith("[")
      ? JSON.parse(formData.contentType).map((c) => c.toString().trim().toLowerCase())
      : typeof formData.contentType === "string"
        ? [formData.contentType.toString().trim().toLowerCase()]
        : [];

  console.log("formData =>> ", formData);
  console.log("contentTypeOptions =>> ", contentTypeOptions);

  return (
    <>
      {console.log("Form Data in contentTypeOptions:", contentTypeOptions)}
      <div className="text-center">
        <p className="text-sm text-gray-500 mt-1"></p>
      </div>

      <div className="space-y-4">
        {/* Title */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Title
          </label>
          <input
            type="text"
            name="title"
            value={formData.title}
            className="mt-1 block w-full py-2 px-4 border rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            placeholder="Enter title"
            onChange={handleInputChange}
            required
          />
        </div>
        {/* Source */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Source
          </label>

          <CreatableMultiSelect
            field="source"
            options={sourceOptions}
            value={(formData.source || []).map(val => {
  const found = sourceOptions.find(opt => opt.value === val);
  return found || { label: val, value: val };
})}
            onChange={(selectedOptions) => {
              const values = selectedOptions.map(opt => opt.value);
              handleDropdownChange("source", values);
            }}
            loadOptions={sourceLoadOptions}
            placeholder="Search sources (Netflix, Prime, etc.)..."
            setOptionsCallback={setSourceOptions}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Content Type
          </label>
          <CreatableMultiSelect
            field="contentType"
            options={contentTypeOptions}
            value={(formData.contentType || []).map(val => {
  const found = contentTypeOptions.find(opt => opt.value === val);
  return found || { label: val, value: val };
})}
            onChange={(selectedOptions) =>
              handleDropdownChange(
                "contentType",
                selectedOptions.map((opt) => opt.value),
              )
            }
            loadOptions={contentTypeLoadOptions}
            placeholder="Search content types (Movie, TV, etc.)..."
            setOptionsCallback={setContenttypeOptions}
          />
        </div>

        {/* target */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            target
          </label>
          <input
            type="text"
            name="target"
            value={formData.target}
            className="mt-1 block w-full py-2 px-4 border rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            placeholder="Enter target"
            onChange={handleInputChange}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
          />
        </div>
      </div>
    </>
  );
};
export default StepBasicMetadata;
